<template>
    <div class="audio-editor-waves">
        <svg
            v-if="paths"
            preserveAspectRatio="none"
            :viewBox="`0 -1 ${peaks} 2`"
            :style="{
                width: `${width}px`,
                height: `${height}px`
            }"
        >
            <g>
                <path :d="paths" :stroke="color" />
            </g>
        </svg>
    </div>
</template>
<script>
import AudioWaveDrawer from './classes/AudioWaveDrawer';

export default {
    name: 'AudioEditorWaves',
    props: {
        url: {
            type: String,
            required: true
        },
        scale: {
            type: Number,
            default: 1
        },
        width: {
            type: [String, Number],
            default: 500
        },
        height: {
            type: [String, Number],
            default: 150
        },
        color: {
            type: String,
            default: '#000'
        }
    },
    data() {
        return {
            drawer: undefined,
            paths: null
        };
    },
    computed: {
        peaks() {
            const result = this.scale * 1000;
            if (result > this.width) return this.width;
            return result;
        }
    },
    watch: {
        peaks(peaks) {
            this.drawer.peaks = peaks;
            this.paths = this.drawer.getPath();
        }
    },
    async created() {
        const { url, peaks } = this;
        this.drawer = new AudioWaveDrawer({ url }, { peaks });
        await this.drawer.loadFromUrl();
        this.paths = this.drawer.getPath();
    },
    methods: {
        reRender() {
            this.$forceUpdate();
        }
    }
};
</script>

<style lang="scss" src="./AudioEditorWaves.scss"></style>
